import { Routes } from "@angular/router";
import { FullComponent } from "./layouts/full/full.component";
import { AuthGuard } from "./services/guards/auth.guard";
import { ErrorPageComponent } from "./pages/error-page/error-page.component";
import { HomeLayoutComponent } from "./pages/home/home-layout.component";
import { NoAuthGuard } from "./services/guards/no-auth.guard";
import { ServerDownComponent } from "./components/misc-component/server-down.component";
import { ServerDownGuard } from "./services/guards/server-down.guard";
import { RoleGuard } from "./services/guards/role.guard";
import { Role } from "./enums/role.enum";

export const routes: Routes = [
  // ---------------- PUBLIC PAGES (WITHOUT LOGIN) ----------------
  {
    path: "",
    component: HomeLayoutComponent,
    children: [
      {
        path: "faq",
        loadComponent: () =>
          import("./pages/home/faq/faq.component").then((m) => m.FaqComponent),
      },
      {
        path: "blog/:slug",
        loadComponent: () =>
          import("./pages/home/blog-detail/blog-detail.component").then((m) => m.BlogDetailComponent),
      },
      {
        path: "blog",
        loadComponent: () =>
          import("./pages/home/blog/blog.component").then((m) => m.BlogComponent),
      },
      {
        path: "about",
        loadComponent: () =>
          import("./pages/home/about-us/about-us.component").then((m) => m.AboutUsComponent),
      },
      {
        path: "contact",
        loadComponent: () =>
          import("./pages/home/contact-us/contact-us.component").then((m) => m.ContactUsComponent),
      },
      {
        path: "return-policy",
        loadComponent: () =>
          import("./pages/home/return-policy/return-policy.component").then((m) => m.ReturnPolicyComponent),
      },
      {
        path: "terms-of-use",
        loadComponent: () =>
          import("./pages/home/terms-of-use/terms-of-use.component").then((m) => m.TermsOfUseComponent),
      },
      {
        path: "privacy",
        loadComponent: () =>
          import("./pages/home/privacy/privacy.component").then((m) => m.PrivacyComponent),
      },
      {
        path: "security",
        loadComponent: () =>
          import("./pages/home/security/security.component").then((m) => m.SecurityComponent),
      },
      {
        path: "home",
        loadComponent: () =>
          import("./pages/home/landing/landing.component").then((m) => m.LandingComponent),
      },
      { path: "", redirectTo: "home", pathMatch: "full" },
    ],
  },
  {
    path: "drizzle-form/:formCode/:formSlug",
    loadComponent: () =>
      import("./pages/home/drizzle-form/drizzle-form.component").then(
        (m) => m.DrizzleFormComponent
      ),
  },
  {
    path: "drizzle-form/:formCode",
    loadComponent: () =>
      import("./pages/home/drizzle-form/drizzle-form.component").then(
        (m) => m.DrizzleFormComponent
      ),
  },
  {
    path: "unsubscribe/:token",
    loadComponent: () =>
      import("./pages/home/unsubscribe/unsubscribe.component").then(
        (m) => m.UnsubscribeComponent
      ),
  },
  {
    path: "unsubscribe",
    loadComponent: () =>
      import("./pages/home/unsubscribe/unsubscribe.component").then(
        (m) => m.UnsubscribeComponent
      ),
  },
  {
    path: "sip-retirement-calculator",
    loadComponent: () =>
      import("./pages/admin/sip-retirement-calculator/sip-retirement-calculator.component").then(
        (m) => m.SipRetirementCalculatorComponent
      ),
  },

  // ---------------- PROTECTED ROUTES (REQUIRES LOGIN) ----------------
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'superadmin',
        canActivate: [RoleGuard],
        data: { roles: [Role.SUPERADMIN] },
        loadChildren: () =>
          import('./pages/superadmin/superadmin.route').then(m => m.SUPER_ADMIN_ROUTES),
      },

      {
        path: 'app',
        canActivate: [RoleGuard],
        data: { roles: [Role.ADMIN, Role.MANAGER, Role.SALES] },
        loadChildren: () =>
          import('./pages/admin/admin.route').then(m => m.APP_ROUTES),
      },

      {
        path: 'admin',
        canActivate: [RoleGuard],
        data: { roles: [Role.ADMIN] },
        loadChildren: () =>
          import('./pages/admin/admin.route').then(m => m.ADMIN_ROUTES),
      },

      {
        path: 'customer',
        canActivate: [RoleGuard],
        data: { roles: [Role.CUSTOMER] },
        loadChildren: () =>
          import('./pages/customer/customer.route').then(m => m.CUSTOMER_ROUTES),
      },
    ],
  },

  // ---------------- AUTHENTICATION ROUTES ----------------
  {
    path: "authentication",
    component: HomeLayoutComponent,
    canActivate: [NoAuthGuard],
    loadChildren: () =>
      import("./pages/authentication/authentication.routes").then(
        (m) => m.AuthenticationRoutes,
      ),
  },

  // ---------------- ERROR PAGES ----------------
  {
    path: "unauthorized",
    component: ErrorPageComponent,
    data: { type: "unauthorized" },
  },

  {
    path: "server-down",
    component: ServerDownComponent,
    canActivate: [ServerDownGuard],
  },

  { path: "**", component: ErrorPageComponent },
];
